import { useState } from 'react';
import s from './AllProducts.module.scss'
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import useGetAllBrands from 'sdk/hooks/shop/useGetAllBrands';
import { useTranslation } from 'react-i18next';

interface AllProductsFilterProps {
  selectedBrand: string;
  setSelectedBrand: (brand: string) => void;
}

const AllProductsFilter = ({ selectedBrand, setSelectedBrand }: AllProductsFilterProps) => {
  const {t} = useTranslation() as any
  const [showDropdown, setShowDropdown] = useState(false);
  const { data: brands } = useGetAllBrands();

  return (
    <div className={s.all_products_filter}>
      <div className={s.all_products_filter_title}>Brand</div>
      <div
        className={s.all_products_filter_selection}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className={s.all_products_filter_selection_title}>
          {selectedBrand || t('All')}
        </div>
        <div className={s.all_products_filter_selection_icon}>
          <IconArrow />
        </div>
      </div>
      {showDropdown && (
        <div className={s.dropdown_menu}>
          <div
            className={s.dropdown_item}
            onClick={() => {
              setSelectedBrand('All');
              setShowDropdown(false);
            }}
          >
            {t('All')}
          </div>
          {brands?.map((brand) => (
            <div
              key={brand.id}
              className={s.dropdown_item}
              onClick={() => {
                setSelectedBrand(brand.name);
                setShowDropdown(false);
              }}
            >
              {brand.name}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default AllProductsFilter 